import { ChangeEvent, useCallback, useEffect } from "react";
import { useState } from "react";
import * as APIModels from "../../../../models";
import { Modal, Button } from "react-bootstrap";
import { UserService } from "../../../../services/ClientService";
import { ClientService } from "../../../../services/ClientService";

import useScript from "../../../../helpers/hooks/useScript";
import background from "../../../../assets/images/multiple-arrow.png";
import Select, { ActionMeta } from "react-select";

type NameValueOptionType = { label: string; value: string };

const AllFrimValue: NameValueOptionType = {
    label: "All",
    value: "0",
};

export type UserAttorneysModalProps = {
    show: boolean;
    userId: string;
    onCancel: () => void;
    onConfirm: () => void;
};

export default function UserAttorneysModal({
    show,
    onCancel,
    userId,
    onConfirm,
}: UserAttorneysModalProps) {
    useScript("/assets/libs/multiselect/js/jquery.multi-select.js");
    const [dbAttorneys, setDBAttorneys] = useState([] as APIModels.Attorney[]);
    const [updatedAttorneys, setUpdatedAttorneys] = useState(
        [] as APIModels.Attorney[]
    );

    const [searching, setSearching] = useState(false);
    const [success, setSuccess] = useState(false);

    const [dbSearchList, setDbSearchList] = useState(
        [] as APIModels.Attorney[]
    );
    const [updatedSearchList, setUpdatedSearchList] = useState(
        [] as APIModels.Attorney[]
    );
    let options: NameValueOptionType[] = [];

    const [firmId, setFirmId] = useState("");
    const [firmOptions, setFirmOptions] = useState(options);

    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        if (show === true) {
            ClientService.myFirms().then(
                (resp) => {
                    if (resp.successful && resp.data) {
                        options = resp.data.map((v, i) => {
                            return { value: v.id!, label: v.name! };
                        });
                        setFirmOptions([AllFrimValue, ...options]);
                        if (options.length == 1) {
                            setFirmId(options[0].value);
                        }
                    } else {
                        //TODO: Show error
                        console.log(resp.errorMessage);
                    }
                },
                (error) => {
                    console.log(error);
                }
            );
            UserService.getAttorneys({
                id: userId ?? "",
            }).then(
                (resp) => {
                    if (resp.successful === true) {
                        setUpdatedAttorneys(resp.data as APIModels.Attorney[]);
                        setUpdatedSearchList(resp.data as APIModels.Attorney[]);
                    } else {
                        console.log("Error");
                    }
                },
                (error: any) => {
                    console.log(error);
                }
            );
        }
    }, [show]);

    const closeWindow = () => {
        setErrorMessage("");
        setDBAttorneys([]);
        setDbSearchList([]);
        setUpdatedAttorneys([]);
        setUpdatedSearchList([]);
        setFirmId("");
        onCancel();
    };

    const confirm = () => {
        onConfirm();
    };

    const updateSelectedAttorneys = (
        event: React.MouseEvent<HTMLSelectElement, MouseEvent>
    ) => {
        const value = Array.from(
            event.currentTarget.selectedOptions,
            (option) => option.value
        );

        const tempDbAttorneys = [...dbAttorneys];

        const stage = [] as APIModels.Attorney[];
        value.forEach((newAttorney) => {
            tempDbAttorneys.forEach((oldAttorney) => {
                if (newAttorney === oldAttorney.id) {
                    stage.push(oldAttorney);
                }
            });
        });

        const tempUpdatedAttorneys = [...updatedAttorneys];
        stage.forEach((stageAtt) => {
            if (
                updatedAttorneys.find((att) => att.id === stageAtt.id) ===
                undefined
            ) {
                tempUpdatedAttorneys.push(stageAtt);
            }
        });

        setUpdatedAttorneys([...tempUpdatedAttorneys]);
        setUpdatedSearchList([...tempUpdatedAttorneys]);
    };

    const removeSelectedAttorneys = (
        event: React.MouseEvent<HTMLSelectElement, MouseEvent>
    ) => {
        const value = Array.from(
            event.currentTarget.selectedOptions,
            (option) => option.value
        );

        const tempUpdatedAttorneys = [...updatedAttorneys];
        value.forEach((valAtt) => {
            if (
                tempUpdatedAttorneys.find((att) => att.id === valAtt) !=
                undefined
            ) {
                const index = tempUpdatedAttorneys.indexOf(
                    updatedAttorneys.find((att) => att.id === valAtt)!,
                    0
                );
                tempUpdatedAttorneys.splice(index, 1);
            }
        });
        setUpdatedAttorneys([...tempUpdatedAttorneys]);
        setUpdatedSearchList([...tempUpdatedAttorneys]);
    };

    const mapSelectedAttorneys = () => {
        setSearching(true);
        setErrorMessage("");

        UserService.linkUserAttorneys({
            id: userId ?? "",
            body: updatedAttorneys,
        }).then(
            (resp) => {
                if (resp.successful === true) {
                    setErrorMessage("Successfully Updated User Attorneys");
                } else {
                    console.log("Error");
                    setErrorMessage("Error: " + resp.errorMessage);
                }
            },
            (error: any) => {
                console.log(error);
            }
        );
        setSuccess(!success);
    };

    useEffect(() => {
        setSearching(false);
    }, [success]);

    const onFilterDbAttorneys = async (
        event: React.FormEvent<HTMLInputElement>
    ) => {
        const stage = [] as APIModels.Attorney[];
        dbSearchList.filter((v, i) => {
            if (
                v
                    .fullName!.toLowerCase()
                    .includes(event.currentTarget.value.toLowerCase()) == true
            ) {
                stage.push(v);
            }
        });

        setDBAttorneys([...stage]);
    };

    const onFilterUpdatedAttorneys = async (
        event: React.FormEvent<HTMLInputElement>
    ) => {
        const stage = [] as APIModels.Attorney[];
        updatedSearchList.filter((v, i) => {
            if (
                v
                    .fullName!.toLowerCase()
                    .includes(event.currentTarget.value.toLowerCase()) == true
            ) {
                stage.push(v);
            }
        });

        setUpdatedAttorneys([...stage]);
    };

    useEffect(() => {
        if (firmId != "") {
            if (firmId === "0") {
                ClientService.firmAttorneys({
                    firmId: APIModels.EmptyGuid,
                }).then(
                    (resp) => {
                        if (resp.successful && resp.data) {
                            options = resp.data.map((v, i) => {
                                return {
                                    value: v.id!,
                                    label: `${v.lastName!}, ${v.firstName!}`,
                                };
                            });
                            setDBAttorneys(resp.data as APIModels.Attorney[]);
                            setDbSearchList(resp.data as APIModels.Attorney[]);
                        } else {
                            //TODO: Show error
                        }
                    },
                    (error) => {
                        console.log(error);
                    }
                );
            } else {
                ClientService.firmAttorneys({ firmId: firmId! }).then(
                    (resp) => {
                        if (resp.successful && resp.data) {
                            options = resp.data.map((v, i) => {
                                return {
                                    value: v.id!,
                                    label: `${v.lastName!}, ${v.firstName!}`,
                                };
                            });
                            setDBAttorneys(resp.data as APIModels.Attorney[]);
                            setDbSearchList(resp.data as APIModels.Attorney[]);
                        } else {
                            //TODO: Show error
                        }
                    },
                    (error) => {
                        console.log(error);
                    }
                );
            }
        }
    }, [firmId]);

    const filterOption = (
        option: NameValueOptionType,
        inputValue: string
    ): boolean =>
        (
            option.label
                .toString()
                .toLowerCase()
                .match(inputValue.toLowerCase()) || []
        ).length > 0;

    const onFirmChange = (
        value: NameValueOptionType | null,
        actionMeta: ActionMeta<NameValueOptionType>
    ) => {
        setFirmId(value!.value);
    };

    return (
        <Modal
            show={show}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    Add/Remove User Attorneys
                </Modal.Title>
            </Modal.Header>
            <Modal.Body
                style={{
                    backgroundImage: `url(${background}) `,
                    backgroundRepeat: "no-repeat",
                    backgroundPositionX: "50%",
                    backgroundPositionY: "65%",
                }}
            >
                <div className="row">
                    <div className="col-6">
                        <label htmlFor="selFirm" className="form-label">
                            Firm
                        </label>
                        {firmOptions.length === 1 ? (
                            <Select
                                id="selFirm"
                                name="selFirm"
                                value={firmOptions.filter(
                                    (c) => c.value === firmId
                                )}
                                options={firmOptions}
                                onChange={onFirmChange}
                            />
                        ) : (
                            <Select
                                id="selFirm"
                                name="selFirm"
                                value={firmOptions.filter(
                                    (c) => c.value === firmId
                                )}
                                filterOption={filterOption}
                                options={firmOptions}
                                onChange={onFirmChange}
                            />
                        )}
                    </div>
                </div>
                <div
                    className="row text-center
                "
                ></div>
                <div className="row text-center">
                    <div className="col-6 mt-3">
                        <p>Available Attorneys</p>
                        <div className="col-9" style={{ marginLeft: "70px" }}>
                            <input
                                id="my_multi_select3"
                                type="text"
                                className="form-control search-input"
                                autoComplete="off"
                                placeholder="search..."
                                onChange={onFilterDbAttorneys}
                                style={{ right: "500px" }}
                            ></input>{" "}
                        </div>

                        <select
                            name="my_multi_select3"
                            className="multi-select"
                            multiple={true}
                            id="my_multi_select3"
                            style={{
                                width: "400px",
                                height: "300px",
                            }}
                            onClick={(event) => updateSelectedAttorneys(event)}
                            data-mdb-filter="true"
                        >
                            {dbAttorneys.map((attorney) => (
                                <option
                                    id="my_multi_select3"
                                    value={attorney?.id}
                                >
                                    {attorney?.fullName}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="col-6 mt-3">
                        <p>User Attorneys</p>
                        <div className="col-9" style={{ marginLeft: "70px" }}>
                            {" "}
                            <input
                                id="my_multi_select3"
                                type="text"
                                className="form-control search-input"
                                autoComplete="off"
                                placeholder="search..."
                                onChange={onFilterUpdatedAttorneys}
                            ></input>
                        </div>

                        <select
                            name="country"
                            className="multi-select"
                            multiple={true}
                            id="my_multi_select3"
                            style={{
                                width: "400px",
                                height: "300px",
                            }}
                            onClick={(event) => removeSelectedAttorneys(event)}
                        >
                            {updatedAttorneys.map((attorney) => (
                                <option value={attorney?.id}>
                                    {attorney?.fullName}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    type="button"
                    className="btn-danger"
                    onClick={closeWindow}
                >
                    Cancel
                </Button>

                {searching ? (
                    <button
                        className="btn btn-primary"
                        type="button"
                        disabled={true}
                    >
                        <span
                            className="spinner-border spinner-border-sm me-1"
                            role="status"
                            aria-hidden="true"
                        ></span>
                        Saving...
                    </button>
                ) : (
                    <button
                        className="btn btn-primary"
                        type="button"
                        onClick={mapSelectedAttorneys}
                    >
                        Save
                    </button>
                )}
            </Modal.Footer>
            <div className="row mb-3">
                <div className="text-center">{errorMessage}</div>
            </div>
        </Modal>
    );
}
